import { QUESTION_VARIABLE } from '../constants';

export const formatQuestion = (questionTitle, name) => {
  return questionTitle.replace(QUESTION_VARIABLE.NAME, name);
};
